const PROBE = "cookie_domain_probe";

let resolved: { domain: string | undefined } | undefined;

// cookieDomain's twin for the browser, without shipping the public suffix list:
// the broadest domain the browser accepts a cookie on is the registrable one,
// as analytics.js's cookieDomain "auto" finds it. Probed once per page.
const browserCookieDomain = (): string | undefined => {
  if (typeof document === "undefined") return undefined;
  resolved ??= { domain: probe(window.location.hostname) };
  return resolved.domain;
};

const probe = (hostname: string) => {
  if (!hostname.includes(".") || isIp(hostname)) return undefined;
  const labels = hostname.split(".");
  for (let start = labels.length - 2; start >= 0; start--) {
    const domain = labels.slice(start).join(".");
    document.cookie = `${PROBE}=1; Path=/; Domain=${domain}`;
    if (document.cookie.split("; ").includes(`${PROBE}=1`)) {
      document.cookie = `${PROBE}=; Path=/; Max-Age=0; Domain=${domain}`;
      return domain;
    }
  }
  return undefined;
};

const isIp = (hostname: string) =>
  hostname.includes(":") || /^\d+(\.\d+){3}$/.test(hostname);

export const resetBrowserCookieDomain = () => {
  resolved = undefined;
};

export default browserCookieDomain;
